import React from 'react';
import moment from 'moment';
import { formatToOrdinal, formatCurrency } from '../../../../../../../../helpers/format';
import { getTournamentBuyinInfo } from './getTournamentBuyinInfo';

export const renderStat = (name, value) => (
    <p className="tournaments__lobby__stat">
        <span className="tournaments__lobby__stat-title">{name}:</span>
        <span className="tournaments__lobby__stat-value">{value}</span>
    </p>
);

const blockForMobile = (data, t) => (
    <React.Fragment>
        {/* will translate 'ID'  */}
        {renderStat(`${t('tournaments.tournament')} ID`, data.tournamentId)}
        {renderStat(t('tournaments.status'), t(`tournaments.${data.tournamentState}`))}
        {renderStat(t('tournaments.startAt'), moment(data.startDate).format('MMM DD, YYYY HH:mm'))}
        {renderStat(t('tournaments.entrants'), `${t('tournaments.max')} ${data.maxPlayersCount} ${t('tournaments.players')}, ${t('tournaments.currently')} ${data.enrolled}`)}
    </React.Fragment>
)

const countDuration = (t, timeWithSeconds, short) => {
    let days = Math.floor((timeWithSeconds / 86400));
    let hours = Math.floor((timeWithSeconds / 3600) % 24);
    let minutes = Math.floor((timeWithSeconds % 3600) / 60);
    let seconds = Math.floor((timeWithSeconds % 3600) % 60);
    if(!short) {
        return (days+`${t('tournaments.days')},`+hours+`${t('tournaments.hours')},`+minutes+`${t('tournaments.mins')},`+seconds+"s");
    }
    if(days){
        return days + `${t('tournaments.days')}`;
    } else if(hours) {
        return hours + `${t('tournaments.hours')}`;
    } else if(minutes) {
        return minutes + `${t('tournaments.mins')}`;
    } else {
        return 'Less than 1min';
    }
}

const blockLeft = (data, t, isMobile) => {
    const currentTime = new Date();
    const sngduration= data.duration ? Number(data.duration.split(':')[0]) * 3600  +  Number(data.duration.split(':')[1]) * 60 : 0;
    const snglefttime = data.tournamentState === 'inProgress' && sngduration ? 
        sngduration + (new Date(moment(data.startDate)).getTime()- currentTime.getTime())/1000 : '';
    const leftTimeWithSeconds = snglefttime || (data.tournamentState === "finished" ? 0 
        : (new Date(moment(data.endDate)).getTime() - currentTime.getTime())/1000);
    const buyIn = data.buyIn.buyin
    const {chipValue} = getTournamentBuyinInfo(data);
    const lateRegDuration = data.tournamentState === 'lateRegistration' ? 
        (new Date(moment(data.registrationEndDate)).getTime() - new Date(moment(data.startDate)).getTime())/1000 : '';
    const leftTimeForReg = lateRegDuration ? (new Date(moment(data.registrationEndDate)).getTime() - currentTime.getTime())/1000 : '';
    return (
        <React.Fragment>
            {renderStat(t('tournaments.gameName'), data.tournamentGames[0] ? data.tournamentGames[0].name : '')}
            {renderStat(t('tournaments.betAmountPerSpin'), data.minBet)}
            {!isMobile && renderStat(t('tournaments.startAt'), moment(data.startDate).format('MMM DD, YYYY HH:mm'))}
            {buyIn ? renderStat(t('tournaments.buyin'), chipValue()): ''}
            {renderStat(t('tournaments.spins'), data.numberOfSpins)}
            {renderStat(t('tournaments.allowedReBuys'), t('tournaments.no'))}
            {isMobile ?
                <React.Fragment>
                    {renderStat(t('tournaments.timeLeft'), countDuration(t, leftTimeWithSeconds, false))}
                    {renderStat(t('tournaments.endDate'), moment(data.endDate).format('MMM DD, YYYY HH:mm'))}
                    {renderStat(t('tournaments.minimumPlayers'), data.minPlayersCount)}
                </React.Fragment>
                :
                <React.Fragment>
                    {/* /rebuy price */}
                    {renderStat(t('tournaments.lateRegistration'), lateRegDuration ? countDuration(t, leftTimeForReg, true) : t('notAvailable') )}
                    {renderStat(t('tournaments.minMaxPlayers'), `${data.minPlayersCount} - ${data.maxPlayersCount}`)}
                </React.Fragment>
            }
        </React.Fragment>
    )
}

const blockRight = (data, t) => {
    const {chipValue} = getTournamentBuyinInfo(data);
    return(
        <React.Fragment>
            {renderStat(t('tournaments.prizePool'), chipValue({val: data.prizePool.value}))}
            {renderStat(t('tournaments.registeredPlayers'), data.enrolled)}
        </React.Fragment>
    )
}

export const renderStatBlockLeft = (data, t) => (
    <React.Fragment>
        {blockLeft(data, t, false)}
    </React.Fragment>
);

export const renderStatBlockRight = (data, t) => blockRight(data, t)

export const renderStatBlockMobile = (data, show, t) => (
    <React.Fragment>
        {blockForMobile(data, t)}
        {show && <React.Fragment>
            {blockLeft(data, t, true)}
            {blockRight(data, t)}
        </React.Fragment>}
    </React.Fragment>
)

export const renderBuyinInfo = (data, t) => {
    const {chipValue} = getTournamentBuyinInfo(data);
    return (
        <React.Fragment>
            {renderStat(t('tournaments.guaranteed'), formatCurrency(data.guaranteed.value, '', data.guaranteed.currency))}
            {renderStat(t('tournaments.buyin'), chipValue())}
            {renderStat(t('tournaments.spins'), data.numberOfSpins)}
        </React.Fragment>
    )
}
